/* global axios */
import ApiClient from './ApiClient';

class FupFlowsAPI extends ApiClient {
  constructor() {
    super('fup_flows', { accountScoped: true });
  }

  getFlows() {
    return axios.get(this.url);
  }

  getFlow(flowId) {
    return axios.get(`${this.url}/${flowId}`);
  }

  createFlow(payload) {
    return axios.post(this.url, { fup_flow: payload });
  }

  updateFlow(flowId, payload) {
    return axios.patch(`${this.url}/${flowId}`, { fup_flow: payload });
  }

  deleteFlow(flowId) {
    return axios.delete(`${this.url}/${flowId}`);
  }
}

export default new FupFlowsAPI();
